var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnauthorized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 368,
    height: 338,
    viewBox: "0 0 368 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M367.75 131.5C367.75 209.648 276.898 338 198.75 338C120.602 338 0.25 271.648 0.25 193.5C0.25 115.352 96.6017 0 174.75 0C252.898 0 367.75 53.3517 367.75 131.5Z",
    fill: "#c2dcf7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.531 147H215.969V116.719C215.969 99.201 201.768 85 184.25 85C166.732 85 152.531 99.201 152.531 116.719V147ZM137.531 147H129.25C123.727 147 119.25 151.477 119.25 157V257C119.25 262.523 123.727 267 129.25 267H239.25C244.773 267 249.25 262.523 249.25 257V157C249.25 151.477 244.773 147 239.25 147H230.969V116.719C230.969 90.9167 210.052 70 184.25 70C158.448 70 137.531 90.9167 137.531 116.719V147Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.25 186C178.727 186 174.25 190.477 174.25 196C174.25 201.523 178.727 206 184.25 206H183.25L177.25 230H191.75L185.75 206H184.25C189.773 206 194.25 201.523 194.25 196C194.25 190.477 189.773 186 184.25 186Z",
    fill: "#D3CCD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorized);
export default __webpack_public_path__ + "static/media/unauthorized.80830d0af0b183c11e5d8cf00e6cf882.svg";
export { ForwardRef as ReactComponent };